/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestSMTP
 */
export interface TestSMTP {
    /**
     * 
     * @type {string}
     * @memberof TestSMTP
     */
    email: string;
}

export function TestSMTPFromJSON(json: any): TestSMTP {
    return TestSMTPFromJSONTyped(json, false);
}

export function TestSMTPFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestSMTP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function TestSMTPToJSON(value?: TestSMTP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}


